(window.webpackJsonp_N_E = window.webpackJsonp_N_E || []).push([
    [1], {
        "+5i3": function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                select__placeholder: "select__placeholder",
                select__control: "select__control",
                "select__single-value": "select__single-value",
                select__menu: "select__menu",
                select__option: "select__option",
                select__indicator: "select__indicator",
                "select__loading-indicator": "select__loading-indicator",
                "select__indicator-separator": "select__indicator-separator",
                select__indicators: "select__indicators",
                "select-bank__options": "select-bank__options",
                "select-bank": "select-bank",
                "select__value-container": "select__value-container",
                "bank-name": "bank-name",
                "bank-account-no": "bank-account-no",
                "custom-input": "custom-input",
                prefix: "prefix",
                text: "text",
                radio: "radio",
                visual: "visual",
                primary: "primary",
                neutral: "neutral",
                tab: "tab",
                active: "active",
                modal: "modal",
                "modal-container": "modal-container",
                icon: "icon",
                "custom-neutral": "custom-neutral",
                "col-md-1": "col-md-1",
                "col-md-2": "col-md-2",
                "col-md-3": "col-md-3",
                "col-md-4": "col-md-4",
                "col-md-5": "col-md-5",
                "col-md-6": "col-md-6",
                "col-md-7": "col-md-7",
                "col-md-8": "col-md-8",
                "col-md-9": "col-md-9",
                "col-md-10": "col-md-10",
                "col-md-11": "col-md-11",
                "col-md-12": "col-md-12",
                "full-width": "full-width",
                m0: "m0",
                p0: "p0",
                mt0: "mt0",
                pt0: "pt0",
                mb0: "mb0",
                pb0: "pb0",
                ml0: "ml0",
                pl0: "pl0",
                mr0: "mr0",
                pr0: "pr0",
                m1: "m1",
                p1: "p1",
                mt1: "mt1",
                pt1: "pt1",
                mb1: "mb1",
                pb1: "pb1",
                ml1: "ml1",
                pl1: "pl1",
                mr1: "mr1",
                pr1: "pr1",
                m2: "m2",
                p2: "p2",
                mt2: "mt2",
                pt2: "pt2",
                mb2: "mb2",
                pb2: "pb2",
                ml2: "ml2",
                pl2: "pl2",
                mr2: "mr2",
                pr2: "pr2",
                m3: "m3",
                p3: "p3",
                mt3: "mt3",
                pt3: "pt3",
                mb3: "mb3",
                pb3: "pb3",
                ml3: "ml3",
                pl3: "pl3",
                mr3: "mr3",
                pr3: "pr3",
                m4: "m4",
                p4: "p4",
                mt4: "mt4",
                pt4: "pt4",
                mb4: "mb4",
                pb4: "pb4",
                ml4: "ml4",
                pl4: "pl4",
                mr4: "mr4",
                pr4: "pr4",
                m5: "m5",
                p5: "p5",
                mt5: "mt5",
                pt5: "pt5",
                mb5: "mb5",
                pb5: "pb5",
                ml5: "ml5",
                pl5: "pl5",
                mr5: "mr5",
                pr5: "pr5",
                m10: "m10",
                p10: "p10",
                mt10: "mt10",
                pt10: "pt10",
                mb10: "mb10",
                pb10: "pb10",
                ml10: "ml10",
                pl10: "pl10",
                mr10: "mr10",
                pr10: "pr10",
                m15: "m15",
                p15: "p15",
                mt15: "mt15",
                pt15: "pt15",
                mb15: "mb15",
                pb15: "pb15",
                ml15: "ml15",
                pl15: "pl15",
                mr15: "mr15",
                pr15: "pr15",
                m20: "m20",
                p20: "p20",
                mt20: "mt20",
                pt20: "pt20",
                mb20: "mb20",
                pb20: "pb20",
                ml20: "ml20",
                pl20: "pl20",
                mr20: "mr20",
                pr20: "pr20",
                m25: "m25",
                p25: "p25",
                mt25: "mt25",
                pt25: "pt25",
                mb25: "mb25",
                pb25: "pb25",
                ml25: "ml25",
                pl25: "pl25",
                mr25: "mr25",
                pr25: "pr25",
                m30: "m30",
                p30: "p30",
                mt30: "mt30",
                pt30: "pt30",
                mb30: "mb30",
                pb30: "pb30",
                ml30: "ml30",
                pl30: "pl30",
                mr30: "mr30",
                pr30: "pr30",
                m35: "m35",
                p35: "p35",
                mt35: "mt35",
                pt35: "pt35",
                mb35: "mb35",
                pb35: "pb35",
                ml35: "ml35",
                pl35: "pl35",
                mr35: "mr35",
                pr35: "pr35",
                m40: "m40",
                p40: "p40",
                mt40: "mt40",
                pt40: "pt40",
                mb40: "mb40",
                pb40: "pb40",
                ml40: "ml40",
                pl40: "pl40",
                mr40: "mr40",
                pr40: "pr40",
                m45: "m45",
                p45: "p45",
                mt45: "mt45",
                pt45: "pt45",
                mb45: "mb45",
                pb45: "pb45",
                ml45: "ml45",
                pl45: "pl45",
                mr45: "mr45",
                pr45: "pr45",
                m50: "m50",
                p50: "p50",
                mt50: "mt50",
                pt50: "pt50",
                mb50: "mb50",
                pb50: "pb50",
                ml50: "ml50",
                pl50: "pl50",
                mr50: "mr50",
                pr50: "pr50",
                m55: "m55",
                p55: "p55",
                mt55: "mt55",
                pt55: "pt55",
                mb55: "mb55",
                pb55: "pb55",
                ml55: "ml55",
                pl55: "pl55",
                mr55: "mr55",
                pr55: "pr55",
                m60: "m60",
                p60: "p60",
                mt60: "mt60",
                pt60: "pt60",
                mb60: "mb60",
                pb60: "pb60",
                ml60: "ml60",
                pl60: "pl60",
                mr60: "mr60",
                pr60: "pr60",
                m65: "m65",
                p65: "p65",
                mt65: "mt65",
                pt65: "pt65",
                mb65: "mb65",
                pb65: "pb65",
                ml65: "ml65",
                pl65: "pl65",
                mr65: "mr65",
                pr65: "pr65",
                m70: "m70",
                p70: "p70",
                mt70: "mt70",
                pt70: "pt70",
                mb70: "mb70",
                pb70: "pb70",
                ml70: "ml70",
                pl70: "pl70",
                mr70: "mr70",
                pr70: "pr70",
                m75: "m75",
                p75: "p75",
                mt75: "mt75",
                pt75: "pt75",
                mb75: "mb75",
                pb75: "pb75",
                ml75: "ml75",
                pl75: "pl75",
                mr75: "mr75",
                pr75: "pr75",
                m80: "m80",
                p80: "p80",
                mt80: "mt80",
                pt80: "pt80",
                mb80: "mb80",
                pb80: "pb80",
                ml80: "ml80",
                pl80: "pl80",
                mr80: "mr80",
                pr80: "pr80",
                m85: "m85",
                p85: "p85",
                mt85: "mt85",
                pt85: "pt85",
                mb85: "mb85",
                pb85: "pb85",
                ml85: "ml85",
                pl85: "pl85",
                mr85: "mr85",
                pr85: "pr85",
                m90: "m90",
                p90: "p90",
                mt90: "mt90",
                pt90: "pt90",
                mb90: "mb90",
                pb90: "pb90",
                ml90: "ml90",
                pl90: "pl90",
                mr90: "mr90",
                pr90: "pr90",
                m95: "m95",
                p95: "p95",
                mt95: "mt95",
                pt95: "pt95",
                mb95: "mb95",
                pb95: "pb95",
                ml95: "ml95",
                pl95: "pl95",
                mr95: "mr95",
                pr95: "pr95",
                m100: "m100",
                p100: "p100",
                mt100: "mt100",
                pt100: "pt100",
                mb100: "mb100",
                pb100: "pb100",
                ml100: "ml100",
                pl100: "pl100",
                mr100: "mr100",
                pr100: "pr100",
                "text-center": "text-center",
                "d-block": "d-block",
                "d-sm-none": "d-sm-none",
                "d-md-none": "d-md-none",
                "d-lg-none": "d-lg-none",
                "d-md-block": "d-md-block",
                "color-primary": "color-primary",
                "color-danger": "color-danger",
                "color-white": "color-white",
                "d-flex": "d-flex",
                "align-middle": "align-middle",
                "justify-between": "justify-between",
                "d-xs-none": "d-xs-none",
                hidden: "hidden",
                hideTransition: "hideTransition",
                showTransition: "showTransition",
                sticky: "sticky",
                noScroll: "noScroll",
                default: "default",
                "login-page": "login-page",
                fc_frame: "fc_frame",
                "fc-widget-normal": "fc-widget-normal",
                "fc-open": "fc-open",
                btn: "btn",
                suffix: "suffix",
                hr: "hr",
                outline: "outline",
                info: "info",
                none: "none",
                "f-header": "f-header",
                bounce: "bounce",
                flash: "flash",
                pulse: "pulse",
                rubberBand: "rubberBand",
                shake: "shake",
                headShake: "headShake",
                swing: "swing",
                tada: "tada",
                wobble: "wobble",
                jello: "jello",
                bounceIn: "bounceIn",
                bounceInDown: "bounceInDown",
                bounceInLeft: "bounceInLeft",
                bounceInRight: "bounceInRight",
                bounceInUp: "bounceInUp",
                bounceOut: "bounceOut",
                bounceOutDown: "bounceOutDown",
                bounceOutLeft: "bounceOutLeft",
                bounceOutRight: "bounceOutRight",
                bounceOutUp: "bounceOutUp",
                fadeIn: "fadeIn",
                fadeInDown: "fadeInDown",
                fadeInDownBig: "fadeInDownBig",
                fadeInLeft: "fadeInLeft",
                fadeInLeftBig: "fadeInLeftBig",
                fadeInRight: "fadeInRight",
                fadeInRightBig: "fadeInRightBig",
                fadeInUp: "fadeInUp",
                fadeInUpBig: "fadeInUpBig",
                fadeOut: "fadeOut",
                fadeOutDown: "fadeOutDown",
                fadeOutDownBig: "fadeOutDownBig",
                fadeOutLeft: "fadeOutLeft",
                fadeOutLeftBig: "fadeOutLeftBig",
                fadeOutRight: "fadeOutRight",
                fadeOutRightBig: "fadeOutRightBig",
                fadeOutUp: "fadeOutUp",
                fadeOutUpBig: "fadeOutUpBig",
                flipInX: "flipInX",
                flipInY: "flipInY",
                flipOutX: "flipOutX",
                flipOutY: "flipOutY",
                lightSpeedIn: "lightSpeedIn",
                lightSpeedOut: "lightSpeedOut",
                rotateIn: "rotateIn",
                rotateInDownLeft: "rotateInDownLeft",
                rotateInDownRight: "rotateInDownRight",
                rotateInUpLeft: "rotateInUpLeft",
                rotateInUpRight: "rotateInUpRight",
                rotateOut: "rotateOut",
                rotateOutDownLeft: "rotateOutDownLeft",
                rotateOutDownRight: "rotateOutDownRight",
                rotateOutUpLeft: "rotateOutUpLeft",
                rotateOutUpRight: "rotateOutUpRight",
                hinge: "hinge",
                rollIn: "rollIn",
                rollOut: "rollOut",
                zoomIn: "zoomIn",
                zoomInDown: "zoomInDown",
                zoomInLeft: "zoomInLeft",
                zoomInRight: "zoomInRight",
                zoomInUp: "zoomInUp",
                zoomOut: "zoomOut",
                zoomOutDown: "zoomOutDown",
                zoomOutLeft: "zoomOutLeft",
                zoomOutRight: "zoomOutRight",
                zoomOutUp: "zoomOutUp",
                slideInDown: "slideInDown",
                slideInLeft: "slideInLeft",
                slideInRight: "slideInRight",
                slideInUp: "slideInUp",
                slideOutDown: "slideOutDown",
                slideOutLeft: "slideOutLeft",
                slideOutRight: "slideOutRight",
                slideOutUp: "slideOutUp",
                output: "output",
                mixin: "mixin",
                credit: "credit",
                hue: "hue"
            }
        },
        "1A9i": function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                fundCharts: "fundCharts",
                chartDescription: "chartDescription",
                chartContainer: "chartContainer",
                chartTypeSelectorContainer: "chartTypeSelectorContainer",
                chartTypeSelector: "chartTypeSelector",
                fundActive: "fundActive",
                categoryActive: "categoryActive",
                fdActive: "fdActive",
                heading: "heading",
                value: "value",
                percent: "percent",
                fundColor: "fundColor",
                fdColor: "fdColor",
                categoryColor: "categoryColor",
                chartNavPeriodContainer: "chartNavPeriodContainer",
                activeNavPeriod: "activeNavPeriod"
            }
        },
        "1XoW": function(o, e, t) {
            o.exports = {
                "fund-collections": "fund-collections",
                layout__header: "layout__header",
                "fund-collections__list-item": "fund-collections__list-item",
                "fund-collections__title": "fund-collections__title"
            }
        },
        "2VBK": function(o, e, t) {
            o.exports = {
                riskMeter: "riskMeter"
            }
        },
        "3ikL": function(o, e, t) {
            o.exports = {
                infoButton: "infoButton",
                infoButtonContent: "infoButtonContent"
            }
        },
        "4V3E": function(o, e, t) {
            o.exports = {
                cell: "cell",
                "sticky-left": "sticky-left",
                "sticky-right": "sticky-right",
                "web-4-0": "web-4-0",
                alignLeft: "alignLeft",
                alignRight: "alignRight",
                alignCenter: "alignCenter",
                borderLeft: "borderLeft",
                borderRight: "borderRight",
                borderBoth: "borderBoth",
                header: "header",
                content: "content"
            }
        },
        "4z4a": function(o, e, t) {
            o.exports = {
                "page-not-found": "page-not-found",
                layout: "layout"
            }
        },
        "6cpB": function(o, e, t) {
            o.exports = {
                topFundIdeas: "topFundIdeas",
                topFundIdeasDesktop: "topFundIdeasDesktop",
                listDescription: "listDescription",
                content: "content",
                navSection: "navSection",
                topFundIdeasMobile: "topFundIdeasMobile",
                carousel: "carousel",
                bottomRow: "bottomRow",
                rowLoader: "rowLoader",
                slideLoader: "slideLoader",
                viewAll: "viewAll"
            }
        },
        "7Qgn": function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                fundDistribution: "fundDistribution",
                fundAllocations: "fundAllocations",
                allocationChart: "allocationChart",
                allocationChartLegend: "allocationChartLegend",
                legendItem: "legendItem",
                legendColor: "legendColor",
                legendLabelContainer: "legendLabelContainer",
                legendLabel: "legendLabel",
                legendLabelValue: "legendLabelValue"
            }
        },
        "7sk2": function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                "fund-list__sticky-header": "fund-list__sticky-header",
                "fund-list__header": "fund-list__header",
                "fund-name": "fund-name",
                goto: "goto",
                name: "name",
                "fund-list__tabs": "fund-list__tabs",
                tab: "tab",
                active: "active",
                "fund-list__table": "fund-list__table",
                row: "row",
                sortingArrow: "sortingArrow",
                content: "content",
                "type-cell": "type-cell",
                "low-risk": "low-risk",
                "moderate-risk": "moderate-risk",
                "moderately-high-risk": "moderately-high-risk",
                "high-risk": "high-risk",
                "nfo-type-cell": "nfo-type-cell",
                badge: "badge",
                dropdownToggler: "dropdownToggler",
                "fund-list__item": "fund-list__item",
                "fund-list__item-logo": "fund-list__item-logo",
                "fund-list__item-name": "fund-list__item-name",
                "fund-list": "fund-list",
                "nfo-fund-list": "nfo-fund-list",
                "fund-list__pagination": "fund-list__pagination",
                "fund-list__pagination-list": "fund-list__pagination-list",
                "fund-list__cell-label": "fund-list__cell-label",
                "collection-list": "collection-list",
                "badge-etf": "badge-etf"
            }
        },
        ANWi: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                truthsAboutInvesting: "truthsAboutInvesting",
                truthsCarousel: "truthsCarousel",
                truthsCarouselArrows: "truthsCarouselArrows",
                isCollapsed: "isCollapsed",
                foldContainer: "foldContainer",
                headingRow: "headingRow",
                heading: "heading",
                viewMore: "viewMore",
                iconWrapper: "iconWrapper",
                toggleText: "toggleText",
                readMore: "readMore",
                indicators: "indicators",
                loggedInTruthsAboutInvesting: "loggedInTruthsAboutInvesting",
                slide: "slide",
                slideNumber: "slideNumber",
                slideContent: "slideContent",
                slideWidth: "slideWidth",
                investingTruthsPopup: "investingTruthsPopup",
                headline: "headline",
                question: "question",
                points: "points",
                smallText: "smallText",
                buttonGroup: "buttonGroup",
                linkButton: "linkButton",
                buttonContent: "buttonContent"
            }
        },
        Aynx: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                siteFooter: "siteFooter",
                footer: "footer",
                summary: "summary",
                disclaimer: "disclaimer",
                fundPageWrapper: "fundPageWrapper",
                fundDetailNavBar: "fundDetailNavBar"
            }
        },
        BeIx: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                fundActionButtons: "fundActionButtons",
                oneTime: "oneTime",
                sip: "sip"
            }
        },
        D6nJ: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                portfolio__performance: "portfolio__performance",
                "portfolio__performance-details": "portfolio__performance-details",
                fieldpair: "fieldpair",
                fieldpair__label: "fieldpair__label",
                fieldpair__text: "fieldpair__text",
                "portfolio__performance-title": "portfolio__performance-title",
                skeleton: "skeleton",
                skeleton__item: "skeleton__item"
            }
        },
        D8Vs: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                fundPageHeader: "fundPageHeader",
                pageHeaderLoggedIn: "pageHeaderLoggedIn",
                isWebview: "isWebview",
                headerContainer: "headerContainer",
                fundHeaderRow: "fundHeaderRow",
                fundHeaderDetails: "fundHeaderDetails",
                fundLogo: "fundLogo"
            }
        },
        E7y5: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                fundInfo: "fundInfo",
                pills: "pills",
                pill: "pill",
                cardHeaderTitle: "cardHeaderTitle",
                fundInfoContent: "fundInfoContent",
                contentWrapper: "contentWrapper",
                rowItem: "rowItem",
                label: "label",
                subLabel: "subLabel",
                rowValue: "rowValue",
                rowSubValue: "rowSubValue",
                modalDescription: "modalDescription",
                radioContainer: "radioContainer",
                radioRowItem: "radioRowItem"
            }
        },
        FAUp: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                "portfolio-reponsive__order": "portfolio-reponsive__order",
                "portfolio-reponsive__investment": "portfolio-reponsive__investment",
                slideInUp: "slideInUp",
                "portfolio-reponsive__order-title": "portfolio-reponsive__order-title",
                "portfolio-reponsive__investment-title": "portfolio-reponsive__investment-title",
                "portfolio-reponsive__order-title--close": "portfolio-reponsive__order-title--close",
                "portfolio-reponsive__investment-title--close": "portfolio-reponsive__investment-title--close",
                "portfolio-reponsive__order-data": "portfolio-reponsive__order-data",
                "portfolio-reponsive__investment-data": "portfolio-reponsive__investment-data",
                fundcard: "fundcard",
                badge: "badge",
                "portfolio-reponsive__actions": "portfolio-reponsive__actions",
                "portfolio-reponsive": "portfolio-reponsive",
                "portfolio-order__tabs": "portfolio-order__tabs",
                tooltipContainer: "tooltipContainer"
            }
        },
        FQFz: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                siteFooter: "siteFooter",
                footer: "footer",
                slideLoader: "slideLoader"
            }
        },
        GLlk: function(o, e, t) {
            o.exports = {
                row: "row",
                checkBox: "checkBox",
                "disabled\u0421heckbox": "disabled\u0421heckbox",
                "web-4-0": "web-4-0",
                dropdownToggler: "dropdownToggler",
                dropdownTrigger: "dropdownTrigger",
                selected: "selected",
                disabled: "disabled",
                "row-clickable": "row-clickable",
                content: "content",
                "row-not-clickable": "row-not-clickable",
                cell: "cell",
                "progress-bar": "progress-bar",
                "stock-selected": "stock-selected",
                "stock-not-selected": "stock-not-selected",
                contextMenuContainer: "contextMenuContainer",
                contextMenu: "contextMenu",
                selectionEnabled: "selectionEnabled",
                contexMenu: "contexMenu",
                clickable: "clickable"
            }
        },
        GdzL: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                "collection-card": "collection-card",
                "collection-card__content": "collection-card__content",
                "collection-card__icon": "collection-card__icon",
                "collection-card__title": "collection-card__title",
                "collection-card__description": "collection-card__description",
                "collection-card--style-error": "collection-card--style-error",
                "collection-card--style-warning": "collection-card--style-warning",
                "collection-card--style-info": "collection-card--style-info",
                "collection-card--style-success": "collection-card--style-success"
            }
        },
        H4oI: function(o, e, t) {
            o.exports = {
                table: "table",
                row: "row",
                headerRow: "headerRow",
                header: "header",
                activeSort: "activeSort",
                sortingArrow: "sortingArrow",
                "sticky-header-cell": "sticky-header-cell",
                checkboxHeaderCell: "checkboxHeaderCell",
                instrumentHeaderCellSelected: "instrumentHeaderCellSelected",
                searchIconCell: "searchIconCell",
                searchTableIcon: "searchTableIcon",
                searchInput: "searchInput",
                input: "input",
                inputCloseBtn: "inputCloseBtn",
                "web-4-0": "web-4-0",
                "header-cell": "header-cell",
                errorState: "errorState",
                errorStateHeading: "errorStateHeading",
                errorStateText: "errorStateText",
                errorSearchState: "errorSearchState",
                errorSearchStateHeading: "errorSearchStateHeading",
                errorSearchStateText: "errorSearchStateText",
                heartIcon: "heartIcon"
            }
        },
        HMcE: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                "fund-name": "fund-name",
                "fund-name__meta": "fund-name__meta",
                goto: "goto",
                "fund-name__close": "fund-name__close",
                "fund-name__arrow-left": "fund-name__arrow-left",
                name: "name",
                "color-primary": "color-primary",
                rating: "rating",
                categories: "categories"
            }
        },
        INp6: function(o, e, t) {
            o.exports = {
                menuIcon: "menuIcon"
            }
        },
        IznM: function(o, e, t) {
            o.exports = {
                fundRisk: "fundRisk",
                riskRow: "riskRow",
                riskRowLabel: "riskRowLabel",
                riskValueWithBar: "riskValueWithBar",
                riskRowValue: "riskRowValue",
                riskDisclaimer: "riskDisclaimer"
            }
        },
        JRwz: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                filter__responsive: "filter__responsive",
                fadeOutLeft: "fadeOutLeft",
                "is-open": "is-open",
                fadeInLeft: "fadeInLeft",
                "filter__responsive-title": "filter__responsive-title",
                "filter__responsive-header": "filter__responsive-header",
                "filter__responsive-body": "filter__responsive-body",
                "filter__responsive-footer": "filter__responsive-footer",
                "clear-filter": "clear-filter",
                "apply-filter": "apply-filter",
                "filter__responsive-close": "filter__responsive-close",
                "filter__responsive-options": "filter__responsive-options",
                "filter__responsive-list--data": "filter__responsive-list--data",
                "custom-checkbox": "custom-checkbox",
                "filter__responsive-list--item": "filter__responsive-list--item",
                icon: "icon",
                "selected-item": "selected-item",
                "filter__responsive-overlay": "filter__responsive-overlay",
                "checkbox-submenus": "checkbox-submenus",
                disabled: "disabled"
            }
        },
        JtFs: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                topRatedHeader: "topRatedHeader",
                topRatedHeaderContent: "topRatedHeaderContent",
                header: "header",
                subHeader: "subHeader",
                ribbon: "ribbon"
            }
        },
        KS9c: function(o, e, t) {
            o.exports = {
                navigation: "navigation",
                pagination: "pagination",
                pageLink: "pageLink",
                breakMe: "breakMe",
                previous: "previous",
                next: "next",
                chevronLeft: "chevronLeft",
                chevronRight: "chevronRight",
                activeLink: "activeLink",
                active: "active"
            }
        },
        KiP4: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                fundSummary: "fundSummary",
                fundSummaryDetails: "fundSummaryDetails",
                rounded: "rounded",
                otherFunds: "otherFunds",
                notEnoughInfo: "notEnoughInfo"
            }
        },
        Kw7u: function(o, e, t) {
            o.exports = {
                buttonLabelModal: "buttonLabelModal",
                rowValueModalContainer: "rowValueModalContainer",
                header: "header",
                rowValueModalBody: "rowValueModalBody",
                modalTrigger: "modalTrigger"
            }
        },
        LLD6: function(o, e, t) {
            o.exports = {
                fundHouseInfo: "fundHouseInfo",
                fundHousePoints: "fundHousePoints",
                fundHouseDescription: "fundHouseDescription"
            }
        },
        M36W: function(o, e, t) {
            o.exports = {
                option: "option",
                right: "right",
                left: "left",
                disabled: "disabled",
                dropdown: "dropdown",
                selected: "selected",
                preffix: "preffix",
                suffix: "suffix",
                title: "title",
                "web-4-0": "web-4-0"
            }
        },
        MrwC: function(o, e, t) {
            o.exports = {
                "portfolio-reponsive__investment-title--close": "portfolio-reponsive__investment-title--close",
                "portfolio-reponsive__investment-title--left": "portfolio-reponsive__investment-title--left",
                "portfolio-reponsive__investment-data": "portfolio-reponsive__investment-data",
                fundcard__metrics: "fundcard__metrics",
                fundcard: "fundcard",
                nextsip: "nextsip",
                fieldpair__label: "fieldpair__label",
                fundcard__nextsip: "fundcard__nextsip",
                portfolio__empty: "portfolio__empty",
                "portfolio-reponsive__investment": "portfolio-reponsive__investment",
                "download-statement-btn": "download-statement-btn",
                hidden: "hidden"
            }
        },
        Qqc1: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                signupBanner: "signupBanner",
                imgContainer: "imgContainer",
                content: "content"
            }
        },
        UZgJ: function(o, e, t) {
            o.exports = {
                actionButton: "actionButton"
            }
        },
        V4z6: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                carouselContainer: "carouselContainer",
                carousel: "carousel",
                carouselSlide: "carouselSlide",
                slideIndicator: "slideIndicator",
                dot: "dot",
                activeSlide: "activeSlide",
                arrowContainer: "arrowContainer",
                carouselArrow: "carouselArrow"
            }
        },
        VTII: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                offcanvas: "offcanvas",
                "order-details": "order-details",
                offcanvas__header: "offcanvas__header",
                offcanvas__content: "offcanvas__content",
                "offcanvas__content-body": "offcanvas__content-body",
                badge: "badge",
                "offcanvas__content-footer": "offcanvas__content-footer",
                "order-details__actions": "order-details__actions",
                "order-details__actions-top": "order-details__actions-top",
                "order-details__actions-bottom": "order-details__actions-bottom",
                "fund-name": "fund-name",
                text: "text",
                "order-details__meta": "order-details__meta",
                fieldpair: "fieldpair",
                fieldpair__label: "fieldpair__label",
                fieldpair__text: "fieldpair__text",
                "fund-link": "fund-link",
                "redeem-fund": "redeem-fund",
                "pin-approval": "pin-approval",
                "cancel-fund": "cancel-fund",
                "pin-approval__loader": "pin-approval__loader",
                loader: "loader",
                "pin-approval__loader-title": "pin-approval__loader-title",
                "pin-approval__loader-description": "pin-approval__loader-description",
                "pin-approval__loader-icon": "pin-approval__loader-icon",
                "pin-approval__failed-title": "pin-approval__failed-title",
                "pin-approval__failed-description": "pin-approval__failed-description",
                "pin-approval__footer": "pin-approval__footer",
                hr: "hr",
                "pin-approval__status": "pin-approval__status",
                "pin-approval__status-link": "pin-approval__status-link",
                "offcanvas__content-header": "offcanvas__content-header",
                "redeem-fund__meta": "redeem-fund__meta",
                "cancel-fund__meta": "cancel-fund__meta",
                "otp-help": "otp-help",
                preffix: "preffix",
                icon: "icon",
                "cancel-failure": "cancel-failure",
                "hide-suffix": "hide-suffix"
            }
        },
        WUTI: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                siteFooter: "siteFooter",
                footer: "footer",
                slideLoader: "slideLoader",
                errorContainer: "errorContainer"
            }
        },
        WYYj: function(o, e, t) {
            o.exports = {
                alignment: "alignment",
                show: "show",
                center: "center",
                left: "left",
                right: "right",
                fullHeight: "fullHeight",
                popupContainer: "popupContainer",
                header: "header",
                closePopupIcon: "closePopupIcon",
                spinClock: "spinClock",
                spinUnClock: "spinUnClock",
                hide: "hide",
                showFromRight: "showFromRight",
                showFromLeft: "showFromLeft",
                hideToRightDelay: "hideToRightDelay",
                hideToLeftDelay: "hideToLeftDelay",
                slideToRight: "slideToRight",
                slideFromRight: "slideFromRight",
                slideToLeft: "slideToLeft",
                slideFromLeft: "slideFromLeft",
                blink: "blink"
            }
        },
        Wj69: function(o, e, t) {},
        XIF2: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                fundSummaryDetailsRow: "fundSummaryDetailsRow",
                summaryRowLeftContent: "summaryRowLeftContent",
                details: "details",
                disabledTitle: "disabledTitle",
                title: "title",
                subtitle: "subtitle",
                "offcanvas__content-body": "offcanvas__content-body",
                bottomSheetContent: "bottomSheetContent",
                infoTitle: "infoTitle",
                content: "content",
                bottomSheetHeader: "bottomSheetHeader",
                bottomSheetDisclaimer: "bottomSheetDisclaimer",
                summaryContentItem: "summaryContentItem",
                titleWithIndicator: "titleWithIndicator",
                percentile: "percentile",
                percentileValue: "percentileValue",
                description: "description",
                readMore: "readMore"
            }
        },
        "Y/Q7": function(o, e, t) {
            o.exports = {
                fundManagers: "fundManagers",
                fundManagerWrapper: "fundManagerWrapper",
                fundManagerRow: "fundManagerRow",
                managerName: "managerName"
            }
        },
        "Yc/Y": function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                filter: "filter",
                filter__title: "filter__title",
                "collapse__header-title": "collapse__header-title",
                filter__item: "filter__item",
                checkboxInput: "checkboxInput",
                "filter__item-selected": "filter__item-selected",
                "clear-filter": "clear-filter",
                icon: "icon",
                "filter__item-selected--option": "filter__item-selected--option",
                "filter__item-fund-type": "filter__item-fund-type",
                collapse__body: "collapse__body",
                "is-open": "is-open",
                "filter__selected-count": "filter__selected-count",
                collapse: "collapse",
                collapse__header: "collapse__header",
                "collapse__body-content": "collapse__body-content",
                "collapse__indicator-icon": "collapse__indicator-icon",
                disabled: "disabled",
                "filter__item-fund-risk": "filter__item-fund-risk",
                "radio__list-item": "radio__list-item",
                title: "title",
                checked: "checked",
                "checkbox__list-item": "checkbox__list-item",
                "checkbox__list-item-title": "checkbox__list-item-title",
                "fund-type": "fund-type",
                "custom-checkbox__field": "custom-checkbox__field",
                text: "text",
                "submenus-list": "submenus-list",
                checkbox__list: "checkbox__list",
                "checkbox-submenus": "checkbox-submenus",
                "custom-checkbox": "custom-checkbox"
            }
        },
        "Z+Ou": function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                topRatedFunds: "topRatedFunds",
                topRatedFundsContainer: "topRatedFundsContainer",
                topRatedFundsCard: "topRatedFundsCard",
                ribbon: "ribbon",
                logo: "logo",
                topRatedFundsData: "topRatedFundsData",
                ratingIndicator: "ratingIndicator",
                subText: "subText",
                topRatedFundsDetails: "topRatedFundsDetails",
                rowInfo: "rowInfo",
                rowInfoMinWidth: "rowInfoMinWidth",
                infoLabel: "infoLabel",
                infoValue: "infoValue",
                topRatedFundsMobile: "topRatedFundsMobile",
                cardHeaderTitle: "cardHeaderTitle",
                slideIndicator: "slideIndicator",
                slideDot: "slideDot",
                activeSlide: "activeSlide"
            }
        },
        ZldP: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                creditRatingBanner: "creditRatingBanner",
                title: "title",
                subTitle: "subTitle",
                elss: "elss",
                debt: "debt"
            }
        },
        aQrU: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                pageContainer: "pageContainer",
                gridCard: "gridCard",
                masonryGrid: "masonryGrid",
                masonryGridColumn: "masonryGridColumn"
            }
        },
        bUFn: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                investmentIdeasContainer: "investmentIdeasContainer",
                investmentIdeas: "investmentIdeas",
                carouselArrows: "carouselArrows",
                idea: "idea"
            }
        },
        eMZ0: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                icon: "icon"
            }
        },
        gJJ4: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                fundcard__metrics: "fundcard__metrics",
                "show-inline": "show-inline",
                fieldpair: "fieldpair",
                fieldpair__text: "fieldpair__text",
                status: "status",
                fundcard__actions: "fundcard__actions",
                "fundcard__actions-top": "fundcard__actions-top",
                "fundcard__actions-bottom": "fundcard__actions-bottom",
                fundcard: "fundcard",
                "fund-link": "fund-link",
                fundcard__orderStatusMessage: "fundcard__orderStatusMessage",
                fundcard__learnMore: "fundcard__learnMore"
            }
        },
        gNOJ: function(o, e, t) {
            o.exports = {
                taxInfoExitLoad: "taxInfoExitLoad",
                taxSection: "taxSection",
                exitLoadSection: "exitLoadSection",
                cardRow: "cardRow",
                description: "description",
                rate: "rate"
            }
        },
        gvbr: function(o, e, t) {
            o.exports = {
                fundHoldings: "fundHoldings",
                headerWrapper: "headerWrapper",
                secondaryHeadingRow: "secondaryHeadingRow",
                viewAll: "viewAll",
                holdingsBody: "holdingsBody",
                filters: "filters",
                radioContainer: "radioContainer",
                radioRowItem: "radioRowItem",
                holdingsList: "holdingsList",
                longList: "longList",
                holdingsListItem: "holdingsListItem",
                holdingListItemContent: "holdingListItemContent",
                progressBar: "progressBar",
                listValue: "listValue",
                skeletonWrapper: "skeletonWrapper"
            }
        },
        i4AD: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                fundCategories: "fundCategories",
                headingRow: "headingRow",
                viewAll: "viewAll",
                categoryList: "categoryList",
                categoryListParent: "categoryListParent",
                content: "content",
                viewAllButton: "viewAllButton"
            }
        },
        lFXo: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                largeTabs: "largeTabs",
                tab: "tab",
                active: "active",
                disabled: "disabled"
            }
        },
        lV7P: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                "profile-page": "profile-page",
                layout: "layout"
            }
        },
        miQz: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                sorting__responsive: "sorting__responsive",
                fadeOutLeft: "fadeOutLeft",
                "is-open": "is-open",
                fadeInLeft: "fadeInLeft",
                "sorting__responsive-title": "sorting__responsive-title",
                "sorting__responsive-header": "sorting__responsive-header",
                "sorting__responsive-body": "sorting__responsive-body",
                "sorting__responsive-footer": "sorting__responsive-footer",
                "clear-filter": "clear-filter",
                "apply-filter": "apply-filter",
                "sorting__responsive-close": "sorting__responsive-close",
                "sorting__responsive-options": "sorting__responsive-options",
                "sorting__responsive-list--data": "sorting__responsive-list--data",
                "sorting__responsive-list-option": "sorting__responsive-list-option",
                "sorting__responsive-list-option--text": "sorting__responsive-list-option--text",
                "sorting__responsive-list--item": "sorting__responsive-list--item",
                icon: "icon",
                "selected-item": "selected-item",
                "sorting__responsive-overlay": "sorting__responsive-overlay"
            }
        },
        mo83: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                navigationTabs: "navigationTabs",
                activeNav: "activeNav",
                fixedNavigationTabs: "fixedNavigationTabs",
                fundFixedHeaderRow: "fundFixedHeaderRow",
                fundFixedLogo: "fundFixedLogo",
                fundFixedHeaderDetails: "fundFixedHeaderDetails",
                actionButtons: "actionButtons",
                fundActionButtons: "fundActionButtons",
                tabsList: "tabsList"
            }
        },
        odGj: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                indicatorContainer: "indicatorContainer",
                indicatorWithArrow: "indicatorWithArrow",
                indicator: "indicator",
                active: "active"
            }
        },
        oizV: function(o, e, t) {
            o.exports = {
                tabGroup: "tabGroup",
                tab: "tab",
                active: "active",
                disabled: "disabled"
            }
        },
        pCtD: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                "portfolio-order__tabs": "portfolio-order__tabs",
                tab: "tab",
                "portfolio-order__tabs-custom--title": "portfolio-order__tabs-custom--title",
                portfolio: "portfolio",
                sidebar: "sidebar",
                sidebar__card: "sidebar__card",
                "portfolio-order__list": "portfolio-order__list",
                fundcard: "fundcard",
                "fundcard__inv-type": "fundcard__inv-type",
                badge: "badge",
                fundcard__name: "fundcard__name",
                name: "name",
                logo: "logo",
                fundcard__metrics: "fundcard__metrics",
                units: "units",
                amount: "amount",
                status: "status",
                fieldpair__label: "fieldpair__label",
                fieldpair__text: "fieldpair__text",
                fundcard__orderSIPMessage: "fundcard__orderSIPMessage",
                fundcard__orderStatusMessage: "fundcard__orderStatusMessage",
                fundcard__learnMore: "fundcard__learnMore"
            }
        },
        qU0z: function(o, e, t) {
            o.exports = {
                "graph-color": "var(--graph-color)",
                "icon-color": "var(--color-primary)",
                "nav-positive-color": "var(--positive-color)",
                "nav-negative-color": "var(--negative-color)",
                "portfolio-investment": "portfolio-investment",
                "portfolio-investment__header": "portfolio-investment__header",
                "portfolio-investment__header-title": "portfolio-investment__header-title",
                "portfolio-investment__header-export": "portfolio-investment__header-export",
                "download-statement-btn": "download-statement-btn",
                text: "text",
                "portfolio-investment__data": "portfolio-investment__data",
                "empty-table": "empty-table",
                searchContainer: "searchContainer",
                searchIconContainer: "searchIconContainer",
                tableSearch: "tableSearch",
                inputContainerWrapper: "inputContainerWrapper",
                inputCloseBtn: "inputCloseBtn",
                tooltipContainer: "tooltipContainer",
                sortable: "sortable",
                arrow: "arrow",
                sorted: "sorted",
                "cell-green": "cell-green",
                "cell-red": "cell-red",
                dropdownToggler: "dropdownToggler",
                errorSearchState: "errorSearchState",
                navigation: "navigation",
                "portfolio-investment__type-action": "portfolio-investment__type-action",
                portfolio__empty: "portfolio__empty",
                skeleton__item: "skeleton__item",
                "portfolio-investment__empty": "portfolio-investment__empty",
                "portfolio__empty-description": "portfolio__empty-description"
            }
        },
        rRti: function(o, e, t) {
            o.exports = {
                "mandate-table": "mandate-table",
                "mandate-head": "mandate-head",
                "mandate-heading": "mandate-heading",
                "mandate-failed": "mandate-failed",
                "mandate-body": "mandate-body",
                "mandate-row": "mandate-row",
                "mandate-label": "mandate-label",
                "mandate-value": "mandate-value"
            }
        },
        sbkz: function(o, e, t) {
            o.exports = {
                container: "container",
                focusable: "focusable",
                position: "position",
                top: "top",
                bottom: "bottom",
                left: "left",
                right: "right",
                wrapper: "wrapper",
                blockDropDown: "blockDropDown",
                noneDropDown: "noneDropDown"
            }
        },
        tEug: function(o, e, t) {
            o.exports = {
                input: "input",
                "with-placeholder": "with-placeholder"
            }
        },
        u7ON: function(o, e, t) {
            o.exports = {
                gridCard: "gridCard",
                cardHeader: "cardHeader",
                cardHeaderTitle: "cardHeaderTitle"
            }
        },
        ufIe: function(o, e, t) {
            o.exports = {
                dropdown: "dropdown",
                animate: "animate",
                zoom: "zoom",
                right: "right",
                top: "top",
                bottom: "bottom",
                left: "left",
                "web-4-0": "web-4-0",
                section: "section",
                sectionTitle: "sectionTitle",
                dropdownTitle: "dropdownTitle"
            }
        },
        vBcS: function(o, e, t) {}
    }
]);